import React, { useState } from 'react'

import DocumentContext from 'contexts/DocumentContext'

import * as service from 'service'

const DocumentsProvider = ({
  children,
  documents,
  linkedDocuments: initialLinkedDocuments,
}) => {
  const [data, setData] = useState(documents)
  const [linkedDocuments, setLinkedDocuments] = useState(
    initialLinkedDocuments ?? [],
  )
  const [loading, setLoading] = useState(false)

  const loadData = async (dataProcessId) => {
    setLoading(true)

    let response = await service.dponet.dataProcesses.get({ dataProcessId })

    setData(response?.data?.dataProcess?.documents)
    setLinkedDocuments(response?.data?.dataProcess?.linkedDocuments ?? [])

    setLoading(false)
  }

  return (
    <DocumentContext.Provider
      value={{
        data,
        setData,
        linkedDocuments,
        setLinkedDocuments,
        loading,
        setLoading,
        loadData,
      }}
    >
      {children}
    </DocumentContext.Provider>
  )
}

export default DocumentsProvider
